<script>
import baseList from "@/views/components/base/baseList.vue";
import { Avatar, Button, Card, Col, Row } from "view-design";
import you from "@/assets/icon/you.png";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "reverbBound",
        key: "bound_id",
        url: {},
        output: false,
      },
      data: {},
      menus: [
        {
          label: "回声树列表",
          name: "reverb_list",
          auth: "/admin/reverb/lists",
          // badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
        {
          label: "助力列表",
          name: "reverb_info",
          auth: "/admin/reverbHelp/lists",
        },
        {
          label: "成员列表",
          name: "reverbBound_list",
          auth: "/admin/reverbBound/lists",
          // badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
      ],
      actions: [],
      tactions: [
        // { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '商家数据', 0), auth: '/admin/spot/lists' },
        // { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '商家数据', 1), auth: '/admin/spot/lists' },
      ],
      query: {
        reverb_id: this.$route?.query?.qv,
      },
      currentRow: null,
      filters: [
        { label: '用户', name: 'user_nick', value: '', type: 'input' },
        { label: '回声树名称', name: 'tree_title', value: '', type: 'input' },
      ],
      tableCols: [
        {
          title: "ID",
          width: 80,
          key: "bound_id",
        },
        {
          title: "用户",
          key: "user_name",
          width: 150,
          // align: "center",
          render: (h, { row }) => {
            let uname = row.user_name;
            let src = row.user_head;
            let uid = row.uid;
            return h(
              "div",
              {
                style: {
                  height: "34px",
                  lineHeight: "34px",
                  overflow: "hidden",
                },
              },
              [
                // h("Avatar", {
                //   props: {
                //     src: src,
                //   },
                //   attrs: {
                //     title: "UID: " + uid,
                //   },
                //   style: {},
                // }),
                h(
                  "span",
                  {
                    attrs: {
                      title: uname,
                    },
                    style: {
                      marginLeft: "5px",
                      width: "auto",
                      height: "34px",
                      overflow: "hidden",
                    },
                  },
                  uname
                ),
              ]
            );
          },
        },
        {
          title: "回声树",
          key: "reverb_name",
          minWidth: 100,
        },
        // {
        //   title: "二维码",
        //   minWidth: 100,
        //   key: "code",
        //   viewimage: true,
        // },
        {
          title: "加入时间",
          key: "create_time",
          minWidth: 100,
        },
        {
          title: "操作",
          align: "center",
          minWidth: 150,
          key: "handle",
          fixed: "right",
          handle: ["delete"],
          auth: {
            del: "/admin/reverbBound/del",
          },
        },
      ],
    };
  },
  created() {},

  methods: {
    ToWater_comment(row) {
      $utils.url.push({
        name: "water_comment",
        query: {
          // action: "water_comment",
          id: row.id,
        },
      });
    },
    Detail(row) {
      this.$Modal.info({
        width: 600,
        closable: true,
        render: () => (
          <div class="renBox">
            <Card bordered={false} dis-hover>
              <p slot="title">
                <strong>加水详情</strong>
              </p>
              <Card dis-hover padding={0} bordered={false} class="item">
                <Row align="middle" gutter={20}>
                  <Col>
                    <Avatar
                      shape="square"
                      size="large"
                      src={row.publish_head}
                    />
                    <p class="name">{row.publish_name}</p>
                  </Col>
                  <Col>
                    <p>
                      <strong>{row.water_num}</strong> 勺
                    </p>
                    <img src={you} />
                  </Col>
                  <Col>
                    <Avatar shape="square" size="large" src={row.by_head} />
                    <p class="name">{row.by_name}</p>
                  </Col>
                </Row>
              </Card>

              <Card dis-hover padding={0} bordered={false} class="item">
                <Row justify="space-between">
                  <Col class="Item_title">
                    <strong>加水时间</strong>
                  </Col>
                  <Col>{row.create_time}</Col>
                </Row>
              </Card>
              <Card bordered={false} dis-hover padding={0} class="item">
                <strong>内容</strong>
                <Card dis-hover padding={5} style={{ marginTop: "10px" }}>
                  {row.content}
                </Card>
              </Card>
            </Card>
          </div>
        ),
      });
    },
    async handleSwitch(row) {
      let q = {};
      q.kv = row.id;
      q.is_choiceness = !row.is_choiceness - 0;
      let res = await $utils.api.load("admin/api/water/edit", q, "post");
      if (code == 1) {
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
